import type React from 'react';

import { Grid, List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ArrowDown from 'assets/icons/icn_16px_arrow_down.svg?react';
import StandardButton from 'components/buttons/StandardButton';
import TMXPopover from 'components/popovers/TMXPopover';
import { useStyles } from 'components/tables/eventsSplitDraws/splitDraws/styles';
import TMXProgressTypography from 'components/typography/progress/TMXProgressTypography';
import { BodyLarge } from 'components/typography/Typography';
import { type FlightProfile } from 'typedefs/store/tmxTypes';

interface SeedingComponentProps {
  achorEl: HTMLElement;
  flights: FlightProfile[];
  isInEditMode: boolean;
  isOpen: boolean;
  loading: boolean;
  isSeedingPublished: boolean;
  isTableEmpty: boolean;
  onChangeIsEdit: () => void;
  onClosePopover: () => void;
  onManualSeeding: () => void;
  onOpenSeedingPopover: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onPublishSeeding: () => void;
  onRemoveSeeding: () => void;
  onUnpublishSeeding: () => void;
  ratingsAndRankingSeedItems?: () => void;
}
const SeedingComponent: React.FC<SeedingComponentProps> = ({
  achorEl,
  flights,
  isInEditMode,
  isOpen,
  loading,
  isSeedingPublished,
  isTableEmpty,
  onChangeIsEdit,
  onClosePopover,
  onManualSeeding,
  onOpenSeedingPopover,
  onPublishSeeding,
  onRemoveSeeding,
  onUnpublishSeeding,
  ratingsAndRankingSeedItems,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const showPublishSeeds = !flights?.length;

  return (
    !isTableEmpty && (
      <Grid container direction="row" flexWrap="nowrap" spacing={1}>
        {isInEditMode && (
          <Grid item width="max-content">
            <StandardButton className={classes.saveSeedsButton} onClick={onChangeIsEdit}>
              {t('saveSeeds')}
            </StandardButton>
          </Grid>
        )}
        <Grid item>
          <StandardButton loading={loading} onClick={onOpenSeedingPopover}>
            {t('seeding')}
            <ArrowDown />
          </StandardButton>
          <TMXPopover anchorEl={achorEl} id="auto-seeding-popover" open={!!achorEl && isOpen} onClose={onClosePopover}>
            <List>
              <>
                {!!ratingsAndRankingSeedItems && ratingsAndRankingSeedItems()}
                <ListItem className={classes.listItem} onClick={onManualSeeding}>
                  <BodyLarge>{t('manualSeeding')}</BodyLarge>
                </ListItem>
                {showPublishSeeds ? (
                  isSeedingPublished ? (
                    <ListItem className={classes.listItem} onClick={onUnpublishSeeding}>
                      <BodyLarge>{t('unpublishSeeding')}</BodyLarge>
                    </ListItem>
                  ) : (
                    <ListItem className={classes.listItem} onClick={onPublishSeeding}>
                      <BodyLarge>{t('publishSeeding')}</BodyLarge>
                    </ListItem>
                  )
                ) : null}
                <ListItem className={classes.listItem} onClick={onRemoveSeeding}>
                  <TMXProgressTypography className={classes.bodyLarge}>{t('clearSeeds')}</TMXProgressTypography>
                </ListItem>
              </>
            </List>
          </TMXPopover>
        </Grid>
      </Grid>
    )
  );
};

export default SeedingComponent;
